import { createFileRoute } from "@tanstack/react-router";
import { PortfolioPage } from "@/features/portfolios/PortfolioPage";

export const Route = createFileRoute("/_app/portfolios/$portfolio")({ component: Page });

function Page() {
  const { portfolio } = Route.useParams();
  return <PortfolioPage id={portfolio} />;
}
